import $axios from '~/plugins/axios';

import { Api, GetPromoParams, Promo, PromoLight } from '~/api';
import { buildModule } from '../utils';
import { createDict, Dict } from '~/helpers';

const api = $axios as Api;

type LazyLoadingParams = Omit<GetPromoParams, 'limit' | 'offset'>;

export default buildModule()
	.withState({
		params: {} as LazyLoadingParams,
		promoByUuid: {} as Dict<Promo | PromoLight>,
		orderedUuids: [] as string[],
	})
	.withGetters({
		params: state => state.params,
		items: (state) => state.orderedUuids.map(uuid => state.promoByUuid[uuid]),
		byUuid: (state) => (uuid: string) => state.promoByUuid[uuid],
	})
	.withMutations({
		RESET (state, params: LazyLoadingParams = {}) {
			state.params = params;
			state.orderedUuids = [];
		},
		APPEND_PROMOS (state, promos: Promo[] | PromoLight[]) {
			state.promoByUuid = { ...state.promoByUuid, ...createDict(promos, ({ uuid }) => uuid) };
			state.orderedUuids = Array.from(new Set([ ...state.orderedUuids, ...promos.map((promo) => promo.uuid) ]));
		},
		SET_PROMOS (state, promos: Promo[] | PromoLight[]) {
			state.promoByUuid = { ...state.promoByUuid, ...createDict(promos, ({ uuid }) => uuid) };
		},
	})
	.withActions({
		async getMore ({ state, commit }, limit: number | null = 20) {
			const params: GetPromoParams = { ...state.params, limit, offset: state.orderedUuids.length };

			const { data } = await api.get('/promo', { params });

			commit('APPEND_PROMOS', data.payload);
		},
		async prefetchPromos ({ commit }, promoUuids: string[]) {
			const promoGetRequests = promoUuids.map((uuid) => api.get(`/promo/${ uuid }`));
			const promoResponses = await Promise.all(promoGetRequests);

			const promos = promoResponses.map((resp) => resp.data.payload);
			commit('SET_PROMOS', promos);
		},
		resetParams ({ state, commit }, params: LazyLoadingParams = {}) {
			commit('RESET', { ...state.params, ...params });
		},
	});
